class VisoStore {
	constructor() {
		this.currentSession = null;
	}

	setCurrentSession(session) {
		this.currentSession = session;
	}

	getCurrentSession() {
		return this.currentSession;
	}
}

export const visoStore = new VisoStore();
